export var easeIn = function easeIn(t, alpha) {
  return Math.pow(t, alpha);
};